const apiKey = import.meta.env.UK_POSTCODE_API_KEY;

export interface IdealPostcodesAddress {
  line_1: string;
  line_2: string;
  line_3: string;
  post_town: string;
  county: string;
  postcode: string;
  country: string;
  premise?: string;
  thoroughfare?: string;
  district?: string;
  udprn: string;
}

export interface IdealPostcodesAddressResponse {
  result: IdealPostcodesAddress[];
  code: number;
  message: string;
}

export const fetchAddresses = async (postcode: string): Promise<IdealPostcodesAddressResponse | undefined> => {
  if (!postcode || postcode.trim() === '') {
    return undefined;
  }
  const cleanPostcode = postcode.replace(/\s+/g, '');
  const url = `https://api.ideal-postcodes.co.uk/v1/postcodes/${encodeURIComponent(cleanPostcode)}?api_key=${apiKey}`;

  const response = await fetch(url);

  if (!response.ok) {
    if (response.status === 404) {
      throw new Error('Postcode not found');
    }
    throw new Error(`API Error: ${response.status}`);
  }

  const data: IdealPostcodesAddressResponse = await response.json();

  if (data.code !== 2000) {
    throw new Error(`Postcode API error: code ${data.code}, ${data.message || 'Unknown error'}`);
  }

  if (!data.result || data.result.length === 0) {
    throw new Error('No addresses found');
  }

  return data;
};
